
    import I18n from 'i18nObj';
    
      import 'translations/outcomes.outcome_group_form';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('outcomes.outcome_group_form');
  